import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import * as moment from 'moment'
import { ApiService } from 'src/app/services/api/api.service';
import { Router, RoutesRecognized } from '@angular/router';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {
  @HostListener('window:scroll', ['$event']) // for window scroll events
  @ViewChild('changePasswordModal', { static: true }) changePasswordModal: any;

  today: any;
  title: any;
  userName: any;
  saved: any;
  token: any;
  scholarId: any;
  currentPassword: any;
  newPassword: any;
  confrimPassword: any;
  wrongConfirmPassword: boolean = false
  messagePassword = ''
  notifications: any = [];
  filterNotif: any = [];
  overallNotification: any = [];
  spinner: boolean;
  mobile: any;

  intervalNotification: any;

  constructor(
    private navService: NavigationService,
    private router: Router,
    private api: ApiService,
    private modalService: NgbModal,
    private _cdRef: ChangeDetectorRef

  ) { }

  async ngOnInit() {

    this.initialLoad()

    this.router.events.subscribe((data) => {
      if (data instanceof RoutesRecognized) {
        if(data.state.root.children[0].data.title == ''){
          this.title = ``
        }else{
        this.title = data.state.root.children[0].data.title;
        }
      }
    });

    if(window.innerWidth < 480){
      this.mobile = true
    }else{
      this.mobile = false
    }

  }

  ngOnDestroy() {
    if (this.intervalNotification) {
      clearInterval(this.intervalNotification);
    }
  }

  onScroll(event) {

    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      if (this.filterNotif.length !== this.overallNotification.length) {        
        this.getNotification(0, this.notifications.length + 9)
        this.spinner = true
      } else {
        this.spinner = false
      }
      
    }
    
    
  }

  toggleSideNav() {
    this.navService.setShowNav(true);
    this.initialLoad()
  }

  async initialLoad() {
    if (localStorage.length !== 0) {
      if (JSON.parse(localStorage.getItem('user_info')).user_id || JSON.parse(localStorage.getItem('user_info')).user_id !== null) {
        const user_data = await JSON.parse(localStorage.getItem('user_info')).user_id
        await this.getScholarData(user_data)
      }

      // var update = function () {
      //   document.getElementById("today").innerHTML = moment().format('MMMM Do YYYY, h:mm:ss a');
      // }
      // setInterval(update, 1000);
      this.getAllNotification()
      this.getNotification()

      this.intervalNotification = setInterval(() => {
        this.getAllNotification()
        // this.getNotification()
      }, 20000);



    }
  }
  async getScholarData(id) {
    try {
      const rawToken = localStorage.getItem('session_id')
      this.token = btoa(rawToken + ':')

      const res2: any = await this.api.getSpecificScholarData2(this.token, id)

      this.userName = res2.display_name
      this.scholarId = res2.scholar_id

      localStorage.setItem('user', JSON.stringify(res2))

    } catch (error) {
      this.saved = { type: 'danger', message: error.message, isShow: true };
      setTimeout(() => { this.saved.isShow = false }, 5000);
    }
  }

  logout() {
    localStorage.getItem('session_id')
    this.router.navigate(['/login'])
    return localStorage.setItem('session_id', '')
  }

  changePassword(changePassword) {
    this.modalService.open(changePassword, { scrollable: true });

  }

  async savePassword() {
    // var data = {
    //   'user_id': '20210011',
    //   'old_pwd': this.currentPassword,
    //   'new_pwd': this.newPassword
    // }


    let formData: any = new FormData();
    formData.append('user_id', this.scholarId)
    formData.append('old_pwd', this.currentPassword)
    formData.append('new_pwd', this.newPassword)

    try {
      const res: any = await this.api.changePassword(formData)
      if (res.status === 'success') {
        this.messagePassword = 'Your password is successfully changed.'
        this.modalService.open(this.changePasswordModal, { centered: true })
      }
    } catch (error) {
      this.messagePassword = 'Incorrect current password.'
      this.modalService.open(this.changePasswordModal, { centered: true })
    }




  }

  closeModalRedirect() {

    this.modalService.dismissAll()

    if (this.messagePassword === 'Your password is successfully changed.') {
      setTimeout(() => {
        localStorage.getItem('session_id')
        this.router.navigate(['/login'])
        return localStorage.setItem('session_id', '')

      }, 500);
    }


  }

  detectConfirmPassword() {
    if (this.confrimPassword !== this.newPassword) {
      this.wrongConfirmPassword = true
    } else {
      this.wrongConfirmPassword = false
    }

  }

  async getAllNotification() {
    const res: any = await this.api.getAllNotifications(this.scholarId, this.token)
    this.overallNotification = res.filter(data => {
      if (data.read === false) return data
    })
    

  }


  async getNotification(start = 0, end = 9) {
    try {
      const res: any = await this.api.getNotifications(this.scholarId, this.token, start, end)

      this.filterNotif = res.filter(data => {
        if (data.read === false) return data
      })
      res.map(data => {
        data.relative_time = moment(data.timestamp).startOf('hours').fromNow();
        data.timestamp = moment(data.timestamp).format('LLL');
      })
      this.notifications = res
    } catch (error) {

    }
  }


  async markAsRead(notif_id, index) {
    const res: any = await this.api.markAsReadNotification(this.scholarId, notif_id)
    if (res.status === 'success') {
      this.getNotification(0, this.notifications.length)
      this.getAllNotification()
    }

  }

  redirect(link) {
    window.open(link, '_blank')
  }


  modalNotificationMobile(modal) {
    this.modalService.open(modal, { scrollable: true });
  }

}